export const inputStyle = {
  width: '100%',
  padding: 10,
  marginBottom: 10,
  borderRadius: 6,
  border: '1px solid #ccc'
};

export const buttonStyleBlue = {
  backgroundColor: '#2196F3',
  color: 'white',
  padding: '10px 20px',
  border: 'none',
  borderRadius: 6,
  cursor: 'pointer'
};

export const buttonStyleGreen = {
  backgroundColor: '#4CAF50',
  color: 'white',
  padding: '10px 20px',
  border: 'none',
  borderRadius: 6,
  cursor: 'pointer',
  marginTop: 10
};

export const buttonStyleRed = {
  backgroundColor: '#f44336',
  color: 'white',
  padding: '10px 20px',
  border: 'none',
  borderRadius: 6,
  cursor: 'pointer',
  marginLeft: 10
};
